import { ProCard } from "@ant-design/pro-components";
import { Table } from "antd";

export const ReviewAddons = ({props}) => {
  const {state} = props;
  const step1Columns = [
    {
      title: "Add-on name",
      dataIndex: "name"
    },
    {
      title: "Type",
      dataIndex: "type"
    },
    {
      title: "Status",
      render: () => <div>Ready to install</div>
    }
  ];

  const step2Columns = [
    {
      title: "Add-on name",
      dataIndex: "name"
    },
    {
      title: "Version",
      dataIndex: "version"
    },
    {
      title: "Configuration",
      render: (_, record) => <div>{record.config ? "Set" : "Not set"}</div>
    }
  ];
  return (
    <div>
       <ProCard split="vertical" style={{ marginTop: 20 }}>
        <ProCard title="Step 1: Select add-ons"  extra={""} headerBordered colSpan="100%" headStyle={{ width: '100%' }}>
          <Table columns={step1Columns} dataSource={state}>

          </Table>
        </ProCard>
      </ProCard>
      <ProCard split="vertical" style={{ marginTop: 20 }}>
        <ProCard title="Step 2: Configure selected add-ons settings"  extra={""} headerBordered colSpan="100%" headStyle={{ width: '100%' }}>
          <Table columns={step2Columns} dataSource={state}>
          </Table>
        </ProCard>
      </ProCard>
    </div>
  )
}